import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        AddNewSharedNoteModal,
        ManageSharedNoteModal,
        ShowNoteModal
    ) {
        this.$state = $state;
        this.AddNewSharedNoteModal=AddNewSharedNoteModal;
        this.ManageSharedNoteModal=ManageSharedNoteModal;
        this.ShowNoteModal=ShowNoteModal;
        this.st= new SmartTable();
    }

    $onInit() {
        const format = date => new Date(date).toString().slice(4, 24);
        this.notes.forEach(note => note.createdOnDisplay = format(note.createdOn));
    }
    
    showAddModal() {
        // this.AddNewSharedNoteModal().then(() => this.reload());;
        this.$state.go(".add");
    }

    showNote(note){
        this.ShowNoteModal('Note', note.note);
    }
    
    showManageModal(note) {
       // return this.ManageSharedNoteModal(note).then(() => this.reload());
       this.$state.go(".manage.edit",{sharedAccountId:note.id, theNote:note});
    }

    reload() {
        return this.$state.reload(this.$state.current);
    }
    
    showShareModal(note) {
        this.$state.go('company.sharing-center.shared-notes.manage.share',{sharedAccount: note,sharedAccountId: note.id});
        

    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/shared-notes.controller.js